export const AUDIT_EVENT_LABELS: Record<string, string> = {
	"login.success": "Вход",
	"login.failed": "Неудачный вход",
	"login.locked": "Аккаунт заперт после промахов",
	"login.banned": "Попытка входа забаненного",
	"login.forbidden": "Нет доступа к бэкофису",
	"session.logout": "Выход",
	"session.terminated": "Сессия завершена",
	"session.terminated_others": "Завершены остальные сессии",
	"login_code.issued": "Выдан код входа",
	"token.reuse_detected": "Повторно использован токен",
	"account.registered": "Регистрация",
	"account.deleted": "Аккаунт удалён",
	"account.delete_rejected": "Удаление без свежего входа",
	"credentials.set": "Заданы email и пароль",
	"telegram.linked": "Привязан Telegram",
	"telegram.link_failed": "Не удалось привязать Telegram",
	"telegram.released": "Telegram отвязан от старой записи",
	"user.banned": "Бан",
	"user.unbanned": "Снят бан",
	"user.role_changed": "Смена роли",
	"group.created": "Добавлена двадцатка",
	"group.updated": "Изменена двадцатка",
	"group.deleted": "Удалена двадцатка",
	"post.surface_shown": "Материал опубликован в приложении",
	"post.surface_hidden": "Материал снят из приложения",
	"bot.created": "Добавлен бот",
	"bot.updated": "Изменён бот",
	"bot.token_replaced": "Заменён токен бота",
	"bot.payment_token_set": "Подключена оплата",
	"bot.payment_token_removed": "Отключена оплата",
	"bot.archived": "Бот убран в архив",
	"bot.restored": "Бот возвращён из архива",
	"scenario.created": "Создан сценарий",
	"scenario.deleted": "Удалён сценарий",
	"scenario.published": "Опубликован сценарий",
	"scenario.version_restored": "Восстановлена версия сценария",
	"broadcast.sent": "Отправлена рассылка",
	"broadcast.scheduled": "Запланирована рассылка",
	"broadcast.cancelled": "Отменена рассылка",
	"audience.exported": "Выгружена аудитория",
}

/** Разделы журнала: по ним события фильтруются одним нажатием. */
export const AUDIT_SERVICES = [
	{ value: "auth", label: "Входы и доступ", prefixes: ["login", "session", "login_code", "token", "account", "credentials", "telegram", "user"] },
	{ value: "catalog.post", label: "Контент", prefixes: ["post"] },
	{ value: "bot-builder", label: "Боты", prefixes: ["bot", "scenario", "broadcast", "audience"] },
	{ value: "catalog.sync", label: "Двадцатки", prefixes: ["group"] },
] as const

export const PLATFORM_LABELS: Record<string, string> = {
	ios: "iOS",
	android: "Android",
	tma: "мини-апп",
	web: "браузер",
}

export const AUDIT_REASON_LABELS: Record<string, string> = {
	unknown_account: "нет такого аккаунта",
	bad_password: "неверный пароль",
	locked: "аккаунт заперт",
	invalid_code: "неверный или истёкший код",
	invalid_init_data: "поддельные данные Telegram",
	account_linked_to_other: "аккаунт привязан к другому Telegram",
	telegram_has_account: "у Telegram уже есть аккаунт",
}

export const AUDIT_LEVEL_LABELS = {
	info: "Инфо",
	warn: "Внимание",
	error: "Тревога",
} as const

export function auditEventLabel(event: string): string {
	return AUDIT_EVENT_LABELS[event] ?? event
}
